module.exports = __webpack_public_path__ + "img/cerrar-sesion.d0434cad.svg";